import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import { PriceOverridesProvider } from './context/PriceOverridesContext';

const SandwichMenuPage = lazy(() => import('./pages/SandwichMenuPage'));
const DeliMenuPage = lazy(() => import('./pages/DeliMenuPage'));
const CateringPage = lazy(() => import('./pages/CateringPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const MiniGamesPage = lazy(() => import('./pages/MiniGamesPage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));

const RouteFallback = () => (
  <div style={{ minHeight: '60vh' }} aria-hidden="true" />
);

function App() {
  return (
    <PriceOverridesProvider>
      <Router>
        <div className="App">
          <Header />
          <main>
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/menu" element={<SandwichMenuPage />} />
                <Route path="/deli" element={<DeliMenuPage />} />
                <Route path="/catering" element={<CateringPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/games" element={<MiniGamesPage />} />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </Router>
    </PriceOverridesProvider>
  );
}

export default App;
